module.exports = __webpack_public_path__ + "img/imagen-air.3c4257b2.png";